<template>
  <app-timeline>
    <app-timeline-item
      v-for="(comment,index) in data"
      :key="index"
      :title="i18nT(`Comment by`)+` ${comment.UserName}`"
      :subtitle="comment.Comment + ''"
      icon="MessageSquareIcon"
      :time="niceDate(comment.UpdatedAt)"
      variant="success"
      :data="comment"
      :onDelete="onDelete"
    />

  </app-timeline>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from './CandidateTimelineItem.vue'
import moment from 'moment'

export default {
  components: {
    AppTimeline,
    AppTimelineItem
  },
  data() {
    return {}
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    onDelete: {
      type: Function,
      default: null
    }
  },
  methods: {
    niceDate(inputDate) {
      return moment(inputDate).format('Do MMM mm:HH')
    }
  }
}
</script>
